import { useMemo } from "react";
import { useRole } from "@/data/RoleContext";
import { getCatalogPermissions, type CatalogPermissions } from "@/data/catalogPermissions";

export function useCatalogPermissions(): CatalogPermissions & { role: string } {
  const { role } = useRole();
  return useMemo(() => ({ ...getCatalogPermissions(role), role }), [role]);
}
